var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousehold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.50065V17.9173H17.5V7.50065L10 2.08398L2.5 7.50065Z",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.166C11.8338 14.6847 10.9585 14.9993 10 14.9993C9.04143 14.9993 8.16628 14.6847 7.5 14.166",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousehold);
export default __webpack_public_path__ + "static/media/household.3019cb9c9d8a5739fa97f34e985d00ff.svg";
export { ForwardRef as ReactComponent };